export interface AssignmentRoleFlags {
  is_hoeppner?: boolean
  is_assigner?: boolean
  is_assignee?: boolean
}

export function hasGlobalAssignmentAccess(user: AssignmentRoleFlags | null | undefined) {
  return Boolean(user?.is_hoeppner || user?.is_assigner)
}

export function isRestrictedAssignee(
  user: AssignmentRoleFlags | null | undefined,
  hasOwnAssignments: boolean,
) {
  return Boolean(user?.is_assignee && !hasGlobalAssignmentAccess(user) && hasOwnAssignments)
}

export function shouldForceOwnDatascope(
  user: AssignmentRoleFlags | null | undefined,
  endpoint: unknown,
) {
  if (hasGlobalAssignmentAccess(user)) return false
  return ["pflichten", "rechtsgrundlagen", "tasks"].includes(String(endpoint || ""))
}
